import { render, staticRenderFns } from "./Edit-user-form.vue?vue&type=template&id=a13e766e"
import script from "./Edit-user-form.vue?vue&type=script&lang=js"
export * from "./Edit-user-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports